import { useFeatureFlag } from '@moda/portal-stanchions';

export const useFineJewelryReturnMessageFlag = () =>
  useFeatureFlag('show-new-message-for-fine-jewelry-returns', [
    { default: false },
    { if: true, then: true }
  ]);
